// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"9ca911fe","609":"648d0918","723":"01a9567c","741":"6e2f17e3","856":"1d777db3","932":"9cd04f80"}[chunkId] + ".chunk.css";
};